export default __webpack_public_path__ + "static/Calibre-MediumItalic-54eefde850c5dd10e9ba35e2b6ffb52a.ttf";